import { ShieldCheck, Award, Clock, HeartPulse, BadgeCheck } from "lucide-react";
import { PROOF } from "@/data/site";

const ITEMS = [
  { icon: BadgeCheck, color: "#FFB703", bg: "#FFF3D1" },
  { icon: Award, color: "#FF70A6", bg: "#FFE1EE" },
  { icon: Clock, color: "#2A9D8F", bg: "#D7F0EC" },
  { icon: ShieldCheck, color: "#4CC9F0", bg: "#DFF6FE" },
  { icon: HeartPulse, color: "#06D6A0", bg: "#D4F7EC" },
];

export default function ProofStrip({ dark = false }) {
  return (
    <section
      className={dark ? "bg-espresso" : "bg-gradient-to-r from-[#FFF3D1] via-[#FFE1EE] to-[#DFF6FE]"}
      data-testid="proof-strip"
    >
      <div className="container-mbf py-8">
        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          {PROOF.map((label, i) => {
            const m = ITEMS[i % ITEMS.length];
            return (
              <div
                key={label}
                className={`flex items-center gap-2.5 rounded-full pl-2 pr-5 py-2 shadow-soft transition-transform duration-300 hover:-translate-y-0.5 ${dark ? "bg-white/10" : "bg-white"}`}
                data-testid={`proof-item-${i}`}
              >
                <span className="w-9 h-9 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: dark ? "rgba(255,255,255,0.12)" : m.bg }}>
                  <m.icon className="w-5 h-5" style={{ color: m.color }} />
                </span>
                <span className={`text-sm font-bold ${dark ? "text-white" : "text-espresso"}`}>{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
